<template>
  <navbar
    position="fixed"
    type="primary"
    :transparent="transparent"
    :color-on-scroll="colorOnScroll"
    menu-classes="ml-auto"
  >
    <template >
      <router-link class="navbar-brand" to="/">
        <img class="img-responsive" style="width:98px;" src="https://sites.appbarber.com.br/assets_site/images/logo3.png" alt="logo">
      </router-link>
      
    </template>
    <template slot="navbar-menu">
      <li class="nav-item">
        <a class="nav-link" href="https://blog.appbarber.com.br" target="_blank" >
          <p>Blog</p>
        </a>
      </li>
      
      <li class="nav-item">
        <a class="nav-link btn btn-neutral" href="https://www.creative-tim.com/product/vue-now-ui-kit-pro" target="_blank">
          <p>Sou Barbeiro</p>
        </a>
      </li>

      <li class="nav-item">
        <a class="nav-link" rel="tooltip" title="Visite nosso canal" data-placement="bottom" href="https://youtube.com/appbarber" target="_blank">
          <i class="fab fa-youtube"></i>
          <p class="d-lg-none d-xl-none">Youtube</p>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" rel="tooltip" title="Curta nosso Facebook" data-placement="bottom" href="https://www.facebook.com/AppBarber.Sistema" target="_blank">
          <i class="fab fa-facebook-square"></i>
          <p class="d-lg-none d-xl-none">Facebook</p>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" rel="tooltip" title="Nos siga no Instagram" data-placement="bottom" href="https://www.instagram.com/appbarber" target="_blank">
          <i class="fab fa-instagram"></i>
          <p class="d-lg-none d-xl-none">Instagram</p>
        </a>
      </li>
    </template>
  </navbar>
</template>

<script>
import { DropDown, NavbarToggleButton, Navbar, NavLink } from '@/components';
import { Popover } from 'element-ui';
export default {
  name: 'main-navbar',
  props: {
    transparent: Boolean,
    colorOnScroll: Number
  },
  components: {
    DropDown,
    Navbar,
    NavbarToggleButton,
    NavLink,
    [Popover.name]: Popover
  }
};
</script>

<style scoped></style>
